import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { STATUS_META, WEEKDAYS, fmtMin, fmtTime, monthLabel, shiftMonth } from "./hrUtils";

/** Colour-coded month calendar. days = [{date,status,...}] from the API. */
export default function AttendanceCalendar({ month, days, onMonth, onPick, compact = false }) {
  const [sel, setSel] = useState(null);
  const first = new Date(`${month}-01T00:00:00`); const lead = (first.getDay() + 6) % 7;
  const pick = (d) => { setSel(d); onPick?.(d); };
  return (
    <div data-testid="attendance-calendar">
      <div className="flex items-center justify-between mb-3">
        <button type="button" data-testid="cal-prev" onClick={() => onMonth(shiftMonth(month, -1))} className="h-8 w-8 grid place-items-center border border-zinc-300 hover:border-zinc-900"><ChevronLeft size={14} /></button>
        <div className="font-heading font-black text-base" data-testid="cal-month">{monthLabel(month)}</div>
        <button type="button" data-testid="cal-next" onClick={() => onMonth(shiftMonth(month, 1))} className="h-8 w-8 grid place-items-center border border-zinc-300 hover:border-zinc-900"><ChevronRight size={14} /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-[10px] uppercase tracking-wider text-zinc-500 mb-1">{WEEKDAYS.map(d => <div key={d} className="text-center">{d}</div>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: lead }).map((_, i) => <div key={`e${i}`} />)}
        {days.map(d => {
          const m = STATUS_META[d.status] || STATUS_META.future; const isSel = sel?.date === d.date;
          return (
            <button key={d.date} type="button" data-testid={`cal-day-${d.date}`} onClick={() => pick(d)} title={m.label}
              className={`${compact ? "h-9" : "h-12 sm:h-14"} flex flex-col items-center justify-center text-xs font-semibold transition-transform hover:scale-[1.04] ${m.cls} ${isSel ? "ring-2 ring-offset-1 ring-zinc-900" : ""}`}>
              <span className="tabular">{Number(d.date.slice(-2))}</span>
              {!compact && d.work_eff_min > 0 ? <span className="text-[9px] font-normal opacity-90">{Math.floor(d.work_eff_min / 60)}h</span> : null}
            </button>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1 mt-3 text-[10px] text-zinc-600">
        {["full", "late", "short", "absent", "paid_leave", "weekly_off", "holiday", "grace"].map(k => <span key={k} className="flex items-center gap-1"><span className={`inline-block h-2.5 w-2.5 ${STATUS_META[k].cls}`} />{STATUS_META[k].label}</span>)}
      </div>
      {sel ? <DayDetail d={sel} /> : null}
    </div>
  );
}

export function DayDetail({ d }) {
  const m = STATUS_META[d.status] || STATUS_META.future;
  return (
    <div className="mt-3 border border-zinc-200 bg-zinc-50 p-3 text-xs" data-testid="day-detail">
      <div className="flex items-center justify-between"><b>{new Date(d.date + "T00:00:00").toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" })}</b><span className={`px-2 py-0.5 text-[10px] font-semibold ${m.cls}`}>{m.label || "—"}</span></div>
      {d.holiday_name ? <div className="mt-1 text-purple-800">{d.holiday_name}{d.half_day ? " (half day)" : ""}</div> : null}
      {d.leave_type ? <div className="mt-1 text-blue-800">{d.leave_type} leave</div> : null}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-2">
        {[["Duty start", fmtTime(d.first_in)], ["Duty end", fmtTime(d.last_out)], ["Working", fmtMin(d.work_eff_min)], ["Lunch", fmtMin(d.lunch_min)], ["Rest", fmtMin(d.rest_min)], ["Late", d.late_min ? `${d.late_min} min` : "—"], ["Short", d.short_min ? fmtMin(d.short_min) : "—"], ["Overtime", d.overtime_min ? fmtMin(d.overtime_min) : "—"]].map(([l, v]) => (
          <div key={l}><div className="text-[9px] uppercase tracking-wider text-zinc-500">{l}</div><div className="font-semibold tabular">{v}</div></div>))}
      </div>
      {d.remarks ? <div className="mt-2 text-zinc-700"><span className="text-[9px] uppercase tracking-wider text-zinc-500">Admin remarks</span><div>{d.remarks}</div></div> : null}
    </div>
  );
}
